import React from "react";
import "./index.scss";
import {createPortal} from "react-dom";
import Button from "features/components/button";
import {TUTORIAL_VIMEO_ID} from "constants.js";

export const Tutorial = (props) => {
    const {onHide} = props;
    return <div className="tutorial">
        <iframe src={`https://player.vimeo.com/video/${TUTORIAL_VIMEO_ID}`}
                title="tutorial video"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
        />
        <Button title={""} onClick={onHide} icon={"close"} type={"square"} />
    </div>
};

/* istanbul ignore next */
export const TutorialModal = props => createPortal(
    <div className={"portal"}><Tutorial {...props}/></div>,
    document.body
);
